(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luuley-contact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('luuley-contact-map')) {
    customElements.define('luuley-contact-map', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-load-map]');
        if (!this.button || this.loaded) return;
        this.loadMap = this.loadMap || (() => {
          if (this.loaded) return;
          this.loaded = true;
          const iframe = document.createElement('iframe');
          iframe.title = 'LUULEY mailing address in Palmdale, California';
          iframe.src = this.dataset.mapUrl;
          iframe.loading = 'eager';
          iframe.referrerPolicy = 'no-referrer';
          iframe.allowFullscreen = true;
          iframe.setAttribute('tabindex', '0');
          iframe.addEventListener('load', () => iframe.focus(), { once: true });
          this.querySelector('[data-map-frame]').replaceChildren(iframe);
          this.querySelector('[data-map-preview]').hidden = true;
          this.querySelector('[data-map-status]').textContent = 'Google Maps opened. This is a mailing address; in-person shopping is not available.';
        });
        this.button.hidden = false;
        this.button.addEventListener('click', this.loadMap);
      }
      disconnectedCallback() {
        if (this.button && this.loadMap) this.button.removeEventListener('click', this.loadMap);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
